export class PatientInfo {
    id: string;
    name: string;
    photoUrl: string;
    patientId: string;
    ssn: string;
    sex: string;
    dob: string;
    mobileNo: string;
    emailId: string;
    backgroundColor: string = 'white';
    doctName: string;
    doctId: string;
    selectedMedicines: any[];
    selectedSurgicalHistory: any[];
    selectedVitamins: any[];
    selectedAllergy: any[];
    dobDate;
    caseTypeName: string;
    anethesia: string;
    referredBy: string;
    surgeon: string;
    assistant: string;
    indication: string;
    room: string;



  }
